import type { CategoryMeta } from "@/types";

export const categories: CategoryMeta[] = [
  {
    key: "movie",
    name: "电影",
    path: "/special/movie",
    desc: "院线新片、口碑佳作与幕后花絮，第一时间掌握大银幕动态。",
    icon: "ri-film-line",
    cover:
      "https://readdy.ai/api/search-image?query=Cinema%20hall%20with%20warm%20projector%20light%20and%20empty%20red%20seats%2C%20moody%20cinematic%20atmosphere%2C%20deep%20blue%20and%20amber%20tones%2C%20minimal%20editorial%20photography%2C%20no%20text&width=600&height=420&seq=cat-movie-01&orientation=landscape",
  },
  {
    key: "tv",
    name: "电视剧",
    path: "/special/tv",
    desc: "热播剧集、剧评解析与追剧指南，陪你度过每一个夜晚。",
    icon: "ri-tv-2-line",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20a%20glowing%20television%20screen%20at%20night%2C%20warm%20lamp%20light%2C%20soft%20cream%20and%20deep%20blue%20tones%2C%20minimal%20editorial%20photography%2C%20no%20text&width=600&height=420&seq=cat-tv-01&orientation=landscape",
  },
  {
    key: "variety",
    name: "综艺",
    path: "/special/variety",
    desc: "真人秀、音乐竞演与脱口秀，收集每周最值得看的快乐。",
    icon: "ri-mic-line",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20stage%20with%20spotlights%20and%20confetti%2C%20energetic%20show%20atmosphere%2C%20warm%20orange%20and%20soft%20cream%20tones%2C%20minimal%20editorial%20photography%2C%20no%20text&width=600&height=420&seq=cat-variety-01&orientation=landscape",
  },
];